// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Sn3Z","card-container":"omMiE","card":"_1kqFx","contentcopy":"_1HyxF"};